import { useRecoilCallback, useRecoilValue } from "recoil";

import { ComposedStack } from "../state/stackSelectors";
import { HostId } from "../state/atoms";
import type { SDK_Stack } from "@quickpoint.me/shared";
import { saveStack } from "../lib/messageBus";

export function useSaveStack() {
	const hostId = useRecoilValue(HostId);
	const save = useRecoilCallback(
		({ snapshot }) =>
			async () => {
				const stackToSave = snapshot.getLoadable(ComposedStack).getValue();
				saveStack(hostId, stackToSave as SDK_Stack);
			},
		[hostId],
	);

	return save;
}
